module.exports = __webpack_public_path__ + "media/images/screens/02_searchBar_filter-8a5c8df82e8a5d9914e0ffb593f5ca52.jpg";